// extracted by mini-css-extract-plugin
export default {"form":"CreateStream_form__4YQRW","details-border":"CreateStream_details-border__ELosO"};